var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "duplicate-action-container" },
    [
      _c(_setup.CustomDialogHeaderComponent, {
        attrs: { headerTitle: _setup.texts.title },
      }),
      _c(
        "div",
        { ref: "nameInput", staticClass: "buttons-container" },
        [
          _c(_setup.LexonTextFieldComponent, {
            attrs: {
              label: _setup.texts.nameLabel,
              id: "name",
              name: "name",
              validationRules: _setup.validationRules,
            },
            model: {
              value: _setup.actionName,
              callback: function ($$v) {
                _setup.actionName = $$v
              },
              expression: "actionName",
            },
          }),
          _c(_setup.LexonSwitchComponent, {
            staticClass: "switch-field",
            attrs: {
              id: "classification",
              name: "classification",
              label: _setup.texts.classificationLabel,
            },
            model: {
              value: _setup.classification,
              callback: function ($$v) {
                _setup.classification = $$v
              },
              expression: "classification",
            },
          }),
        ],
        1
      ),
      _c(_setup.CustomDialogActionButtonsComponent, {
        attrs: {
          disabledButtons: _setup.disabledActionButton,
          mainAction: _setup.duplicateExpedient,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }